import type { MailboxInfo } from "owa-client-types";
import type { SearchScope } from "owa-search-service";
import isGenWebQueryOnTypeEligible from "./isGenWebQueryOnTypeEligible";
import isOriginalGenWebQueryOnTypeExperienceEnabled from "./isOriginalGenWebQueryOnTypeExperienceEnabled";

export interface QueryOnTypeQfOptions {
    isEnabled: boolean;
    shouldSuppressScopedSuggestions: boolean;
}

export default function getQueryOnTypeQfOptions(mailboxInfo: MailboxInfo, searchScope?: SearchScope): QueryOnTypeQfOptions {
    const isOriginalQueryOnTypeExperienceEnabled = isOriginalGenWebQueryOnTypeExperienceEnabled(mailboxInfo);
    
    return {
        isEnabled: isOriginalQueryOnTypeExperienceEnabled,
        shouldSuppressScopedSuggestions: isOriginalQueryOnTypeExperienceEnabled &&
            isGenWebQueryOnTypeEligible(searchScope, mailboxInfo),
    };
}
